import { render, staticRenderFns } from "./planreview.vue?vue&type=template&id=090d6560&scoped=true"
import script from "./planreview.js?vue&type=script&lang=js&external"
export * from "./planreview.js?vue&type=script&lang=js&external"
import style0 from "./planreview.vue?vue&type=style&index=0&id=090d6560&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090d6560",
  null
  
)

export default component.exports